{
  "alert": "Предупреждение",
  "dismiss": "Пропустить"
}